import styled from "@emotion/styled";

import { H2Container, H3Container } from "shared/components/content/content-summary/styles";
import { fontMerriweather, fontRoboto, fontRobotoCondensed, theme } from "shared/lib/styles";

import { FlexContainer as ContentActionBar } from "scmp-app/components/content/content-action-bar/styles";
import { Flag } from "scmp-app/components/content/content-headline/content-headline-tag/styles";
import {
  Headline as ContentHeadline,
  SponsorHeadline,
} from "scmp-app/components/content/content-headline/styles";
import { StyledTopicLink } from "scmp-app/components/content/content-topic-link/styles";
import { EntityLink } from "scmp-app/components/entity-link";
import { MyDailyFiveNumber } from "scmp-app/components/my-news/my-daily-five/my-daily-five-number";

export const Container = styled.div`
  display: flex;
  flex-wrap: nowrap;

  margin-block-end: 20px;
  padding-block-end: 20px;
  border-block-end: 1px solid #e9e9e9;

  ${theme.breakpoints.up("tablet")} {
    margin-block-end: 28px;
    padding-block-end: 0;
    border-block-end: 0;
  }
  ${theme.breakpoints.up("mediumDesktop")} {
    margin-block-end: 0;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column-reverse;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
  }

  ${theme.breakpoints.up("mediumDesktop")} {
    flex-direction: column;
  }
`;

export const ContentWrapper = styled.div`
  ${theme.breakpoints.up("desktop")} {
    margin-block-end: 20px;
  }
  ${theme.breakpoints.up("tablet")} {
    inline-size: calc(50% - 25px);
    margin-inline-end: 20px;
  }
  ${theme.breakpoints.up("mediumDesktop")} {
    inline-size: 100%;
  }
`;

export const Headline = styled.div`
  margin-block-end: 12px;
  ${ContentHeadline}, ${SponsorHeadline}, ${Flag} {
    color: #000000;
    font-size: 16px;
    font-family: ${fontMerriweather};
    line-height: 140%;
    ${theme.breakpoints.up("tablet")} {
      font-size: 22px;
    }
  }
`;

export const Summary = styled.div`
  ${H2Container}, ${H3Container} {
    display: none;

    margin-block-end: 12px;

    color: #666666;
    font-size: 14px;
    font-family: ${fontRoboto};
    line-height: 130%;

    ${theme.breakpoints.up("tablet")} {
      display: block;
    }
  }
`;

export const ActionBar = styled.div`
  ${ContentActionBar} {
    time {
      color: #999999;
      font-size: 12px;
      line-height: 14px;
    }
  }
`;

export const StyledNumber = styled(MyDailyFiveNumber)`
  margin-inline-end: 18px;
  ${theme.breakpoints.up("tablet")} {
    margin-inline-end: 16px;
  }
`;

export const StyledEntityLink = styled(EntityLink)`
  display: block;
`;

export const CoverContainer = styled.div`
  margin-block-end: 12px;

  border-radius: 8px;

  overflow: hidden;

  figure {
    aspect-ratio: 267/200;
    ${theme.breakpoints.up("tablet")} {
      aspect-ratio: 442/295;
    }
    ${theme.breakpoints.up("mediumDesktop")} {
      aspect-ratio: 522/348;
    }
  }

  ${theme.breakpoints.up("tablet")} {
    inline-size: calc(50% + 25px);
    margin-block-end: 0;
  }

  ${theme.breakpoints.up("mediumDesktop")} {
    inline-size: calc(100% + 48px);
    margin-inline-start: -48px;
  }
`;

export const TopicLink = styled.div`
  ${StyledTopicLink} {
    margin-block-end: 8px;

    color: #000000;
    font-weight: 700;
    font-size: 15px;
    font-family: ${fontRobotoCondensed};
    line-height: normal;
  }
`;
